/**
 * Password Validation Module
 *
 * Handles client-side password validation for inputs with 'password-validate' attribute.
 */

export const initConfirmPasswordValidation = () => {
	const confirmPasswordInputs = document.querySelectorAll('input[confirm-password-validate]');
	const passwordInput = document.querySelector('input[target-confirm-password="confirm-password"]');

	if (!confirmPasswordInputs.length || !passwordInput) {
		return;
	}

	confirmPasswordInputs.forEach((input) => {

		input.addEventListener('input', () => {
			validateConfirmPassword(input, passwordInput);
		});
	});
};

/**
 * Validate password value
 *
 * @param {HTMLInputElement} input The input element to validate
 */
const validateConfirmPassword = (input, passwordInput) => {
	const value = input.value;
	const wrapper = input.closest('.form-wrapper');
	const helperText = wrapper ? wrapper.querySelector('.form-helper-text') : null;

	if (!value) {
		clearError(input);
		return;
	}

	if (value !== passwordInput.value) {
		setError(wrapper, helperText, wpcore.direct_t({ en: 'Passwords do not match', fr: 'Les mots de passe ne correspondent pas' }));
	} else {
		clearError(input);
	}
};

/**
 * Set error state
 *
 * @param {HTMLElement} wrapper The form wrapper element
 * @param {HTMLElement} helperText The helper text element
 * @param {string} message The error message
 */
const setError = (wrapper, helperText, message) => {
	if (wrapper) {
		wrapper.classList.add('form-wrapper-error');
	}
	if (helperText) {
		helperText.classList.add('block!');
		helperText.textContent = message;
	}
};

/**
 * Clear error state
 *
 * @param {HTMLInputElement} input The input element
 */
const clearError = (input) => {
	const wrapper = input.closest('.form-wrapper');
	const helperText = wrapper ? wrapper.querySelector('.form-helper-text') : null;

	if (wrapper) {
		wrapper.classList.remove('form-wrapper-error');
	}
	if (helperText) {
		helperText.classList.remove('block!');
		helperText.textContent = '';
	}
};
